module.exports = __webpack_public_path__ + "static/alexStandard-58caa41310237d8964853bb8ab63a385.pdf";